import { render } from "./NewDonorRegistrationForm.vue?vue&type=template&id=19db947d&scoped=true"
import script from "./NewDonorRegistrationForm.vue?vue&type=script&lang=js"
export * from "./NewDonorRegistrationForm.vue?vue&type=script&lang=js"

import "./NewDonorRegistrationForm.vue?vue&type=style&index=0&id=19db947d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db947d"]])

export default __exports__